import { useState } from "react";
import PaymentMethods from "../components/PaymentMethods";
import Brands from "../components/Brands";
import ContactDetails from "../components/ContactDetails";
import agp2 from "../assets/img/agp2.webp";
import agp1 from "../assets/img/agp1.webp";
import agp3 from "../assets/img/agp3.webp";
import agp4 from "../assets/img/agp4.webp";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
  const images = [agp1, agp2, agp3, agp4];
  const [selectedImage, setSelectedImage] = useState(images[0]);
  const { t } = useTranslation();

  return (
    <>
      <div className="about-us container py-5">
        <h1 className="text-color-bright text-center mb-4">
          Akad Gate Pharmacy
        </h1>
        <div className="row flex-column-reverse flex-md-row">
          {/* LEFT TEXT */}
          <div className="col-md-7">
            <div className="about-left">
              <p className="text-main-muted text-start">
               {t('Welcome to AKAD Gate Pharmacy, where our commitment to genuine products and exceptional service has been the cornerstone of our mission since our establishment in 2016 in Ankawa. Over the years, we have proudly served our community with integrity, providing maximum service to our patients and customers. In 2022, we expanded our reach by opening our second branch, furthering our dedication to offering quality healthcare solutions. At AKAD Gate Pharmacy, our team of professional pharmacists is here to guide you through your healthcare journey. you are seeking knowledge about prescribed medications or looking for personalized advice, our pharmacists are committed to providing you with the highest level of care.')}
              </p>

              {/* Social Links */}
              <ul className="about-links d-flex gap-2 align-items-center list-unstyled mt-4 mb-0">
                <li>
                  <a
                    href="https://www.facebook.com/AkadPharmacy"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Facebook"
                  >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon icon-tabler icon-tabler-brand-meta"
                            width="28"
                            height="28"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="#2c3e50"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                            <path
                                d="M12 10.174c1.766 -2.784 3.315 -4.174 4.648 -4.174c2 0 3.263 2.213 4 5.217c.704 2.869 .5 6.783 -2 6.783c-1.114 0 -2.648 -1.565 -4.148 -3.652a27.627 27.627 0 0 1 -2.5 -4.174z"
                            />
                            <path
                                d="M12 10.174c-1.766 -2.784 -3.315 -4.174 -4.648 -4.174c-2 0 -3.263 2.213 -4 5.217c-.704 2.869 -.5 6.783 2 6.783c1.114 0 2.648 -1.565 4.148 -3.652c1 -1.391 1.833 -2.783 2.5 -4.174z"
                            />
                        </svg>                  
                    </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/akad_gate_pharmacy"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Instagram"
                  >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon icon-tabler icon-tabler-brand-instagram"
                            width="28"
                            height="28"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="#2c3e50"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                            <path
                                d="M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z"
                            />
                            <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"/>
                            <path d="M16.5 7.5l0 .01"/>
                        </svg>                  
                    </a>
                </li>
                <li>
                  <a
                    href="https://www.snapchat.com/add/akadgate-pharma"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Snapchat"
                  >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-brand-snapchat"
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="#2c3e50"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path
                            d="M16.882 7.842a4.882 4.882 0 0 0 -9.764 0c0 4.273 -.213 6.409 -4.118 8.118c2 .882 2 .882 3 3c3 0 4 2 6 2s3 -2 6 -2c1 -2.118 1 -2.118 3 -3c-3.906 -1.709 -4.118 -3.845 -4.118 -8.118zm-13.882 8.119c4 -2.118 4 -4.118 1 -7.118m17 7.118c-4 -2.118 -4 -4.118 -1 -7.118"
                        />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* RIGHT IMAGES */}
          <div className="col-md-5">
            <div className="about-right text-center">
              {/* Big image */}
              <div className="main-image mb-3">
                <img
                  src={selectedImage}
                  alt="Akad Gate Pharmacy"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: "350px", objectFit: "cover" }}
                />
              </div>

              {/* Thumbnails */}
              <div className="d-flex justify-content-start gap-2 flex-wrap">
                {images.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumb ${i + 1}`}
                    className={`img-thumbnail border ${
                      selectedImage === img ? "border-primary" : ""
                    }`}
                    style={{
                      width: "70px",
                      height: "70px",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <PaymentMethods />
      <Brands />
      <ContactDetails />
    </>
  );
};

export default AboutUs;